import { render } from "./EditProjectDialog.vue?vue&type=template&id=4a9b27c2"
import script from "./EditProjectDialog.vue?vue&type=script&lang=js"
export * from "./EditProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__